<rt-group variant="horizontal" layout-justify-flex-end>
  <rt-follow-button
    [type]="'offer'"
    [followed]="offer.followed"
    [loading]="followLoading"
    [kind]="offer.kind"
    (followClick)="toggleFollow.emit(offer)"
    (unfollowClick)="toggleFollow.emit(offer)"
  />

  @if (hasPromote) {
    <rt-icon-button
      variant="plain"
      iconName="bullhorn"
      [routerLink]="['/offers', offer.slug, 'promote']"
      margin-lr-small-xx
    />
  }

  @if (hasEdit) {
    <rt-icon-button variant="plain" iconName="edit" (click)="editOffer()" margin-lr-small-xx />
  }
  @if (canManageJobs) {
    <rt-actions-dropdown-container [offer]="offer" type="table" margin-left-small-xx />
  }
</rt-group>
